<template>
  <gl-table-two-columns title="Stats" :rows="prepareData()" />
</template>

<script>
import GlTableTwoColumns from '@gl/GlTableTwoColumns/GlTableTwoColumns'

export default {
  name: 'AddressDetailsStats',
  components: { GlTableTwoColumns },
  props: {
    stats: {
      type: Object,
      required: true,
    },
  },
  methods: {
    prepareData() {
      return [
        {
          title: 'Total Received',
          value: this.stats.totalReceived / 100000000 + ' PLC',
        },
        {
          title: 'Total Sent',
          value: this.stats.totalSent / 100000000 + ' PLC',
        },
        {
          title: 'Total Balance',
          value:
            (this.stats.totalReceived - this.stats.totalSent + this.stats.mintingFrozen) /
              100000000 +
            ' PLC',
        },
        {
          title: 'Total Frozen',
          value: this.stats.mintingFrozen / 100000000 + ' PLC',
        },
        {
          title: 'Available',
          value: (this.stats.totalReceived - this.stats.totalSent) / 100000000 + ' PLC',
        },
      ]
    },
  },
}
</script>
